import React, {Fragment, useState} from "react";

import './FilterPicker.scss';

const FilterPicker = ({onChange, values, name, initialValue}) =>
{
   const [ selected, setSelected ] = useState ( initialValue ) ;
   const onRBhange = (e) =>
   {
      setSelected(e) ;
      onChange(e) ;
   }

   const isSelected = (offset) =>
   {
      return selected === offset ;
   }

   const widthCalc = () =>
   {
      return 100 / values.length ;
   }

   const buttons = ( values ) =>
   {
      return values.map ((value, index) =>
      {
         const id = name + '_item_' + value.offset ;

         return (
            <Fragment key={value.offset}>
               <input key={id + 'r1'} type="radio" id={id} name="selector" checked={ isSelected(value.offset)} onChange={() => onRBhange(value.offset)}/>
               <label key={id + 'r2'} htmlFor={id} style={{width: widthCalc() + '%'}}>{value.label}</label>
            </Fragment>
         )
      })
   }

   return (
      <div className="radio-group-ns" key='rnd'>
         {buttons(values)}
      </div>
   )
}
export { FilterPicker } ;